import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { videoCategories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsSearchOpen(false);
  }, [location]);

  return (
    <header>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-background-100/95 backdrop-blur-md shadow-[0_1px_0_oklch(var(--background-300)/0.3)]'
            : 'bg-transparent'
        }`}
      >
        <div className="container-site flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0" aria-label="妖精视频首页">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-circle-fill text-background-50 text-xl" style={{ width: '20px', height: '20px' }}></i>
            </div>
            <span className="text-xl font-bold text-foreground-950 font-heading whitespace-nowrap">
              妖精视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
              }`}
            >
              首页
            </Link>
            {videoCategories.map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => setIsSearchOpen(!isSearchOpen)}
              className="w-9 h-9 flex items-center justify-center rounded-full text-foreground-600 hover:text-foreground-900 hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-full text-foreground-600 hover:text-foreground-900 hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-lg ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {isSearchOpen && (
          <div className="border-t border-background-300/50 bg-background-100/95 backdrop-blur-md">
            <div className="container-site py-3">
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
                <input
                  type="text"
                  placeholder="搜索视频、电视剧、综艺..."
                  className="w-full pl-10 pr-4 py-2.5 bg-background-200 border border-background-300/50 rounded-full text-sm text-foreground-800 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500/50 transition-colors"
                />
              </div>
            </div>
          </div>
        )}

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-background-300/50 bg-background-100/95 backdrop-blur-md">
            <div className="container-site py-4 flex flex-col gap-1">
              <Link to="/" className="px-4 py-3 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-200 rounded-lg whitespace-nowrap">
                首页
              </Link>
              {videoCategories.map(cat => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-4 py-3 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-200 rounded-lg whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="px-4 py-3 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-200 rounded-lg whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
      <div className="h-16"></div>
    </header>
  );
}